import {
  IConnectionConfigEnvironment,
  IConnectionTypes,
  IPartnerApplicationTypes,
  IUsageIndicators,
} from 'types/graphqlTypes'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const EdiOutboundConnectionConfigModalSchema = yup.object({
  /**
   * @example '4'
   */
  id: yup.string(),
  /**
   * @example { id: '1241', text: '1720-shipper', data: { __typename: 'ShipperApplication' } }
   */
  company: yup
    .object({
      id: yup.string(),
      text: yup.string(),
      data: yup.object({
        __typename: yup
          .mixed<IPartnerApplicationTypes>()
          .oneOf([...Object.values(IPartnerApplicationTypes)]),
      }),
    })
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'SFTP_WITH_PASSWORD'
   */
  connectionType: yup
    .mixed<IConnectionTypes>()
    .oneOf([...Object.values(IConnectionTypes)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example true
   */
  isDisabled: yup.boolean().default(true).required(REQUIRED_MESSAGE),
  /**
   * @example 'production'
   */
  environment: yup
    .mixed<IConnectionConfigEnvironment>()
    .oneOf([...Object.values(IConnectionConfigEnvironment)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example '00401'
   */
  interchangeVersion: yup.string(),
  /**
   * @example '004010'
   */
  groupVersion: yup.string(),
  /**
   * @example 'CASS'
   */
  isaReceiverId: yup.string(),
  /**
   * @example '03'
   */
  isaReceiverIdQualifier: yup.string(),
  /**
   * @example 'TFXH'
   */
  isaSenderId: yup.string().default('TFXH'),
  /**
   * @example '02'
   */
  isaSenderIdQualifier: yup.string().default('02'),
  /**
   * @example 'CASS'
   */
  gsReceiverId: yup.string(),
  /**
   * @example 'TFXH'
   */
  gsSenderId: yup.string(),
  /**
   * @example 'NESTLE_CASS_OVERRIDE'
   */
  destinationOverride: yup.string(),
  /**
   * @example TEST
   */
  testIndicator: yup.mixed<IUsageIndicators>().oneOf([...Object.values(IUsageIndicators)]),
  /**
   * @example '~'
   */
  segmentSeparator: yup.string(),
  /**
   * @example '*'
   */
  elementSeparator: yup.string(),
  /**
   * @example '>'
   */
  componentSeparator: yup.string(),
  /**
   * @example '^'
   */
  repetitionSeparator: yup.string(),
  /**
   * @example 'edi-file-server.transfix.io'
   */
  host: yup.string(),
  /**
   * @example '22'
   */
  port: yup.number(),
  /**
   * @example 'tfxh-1edi'
   */
  username: yup.string(),
  /**
   * @example 'EDI_AWS_SECRET_KEY'
   */
  secretKey: yup.string(),
  /**
   * @example 'PROD/FromMtd/' | 'PROD/ToMtd/'
   */
  pathPrefix: yup.string(),
  /**
   * @example 2
   */
  as2ConnectionConfigId: yup.string(),
  /**
   * @example true
   */
  expect997s: yup.boolean().default(true).required(REQUIRED_MESSAGE),
})

export type TEdiOutboundConnectionConfigModalSchema = yup.InferType<
  typeof EdiOutboundConnectionConfigModalSchema
>
